<template>
	<el-container>
		<el-main style="width: 100%;height: 100%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">Middleman管理</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">服务监控</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div style="width: 100%;margin-top: 20px;">
				<div class="count">
					<div class="count1"><span class="count_span1">当前应用使用内存：</span><span class="count_span">{{totalMemory}}</span>
					</div>
					<div class="count2"><span class="count_span1">当前应用最大可使用内存：</span><span class="count_span">{{maxMemory}}</span></div>
					<div class="count2"><span class="count_span1">当前应用cpu使用率：</span><span class="count_span">{{cpuRatio}}</span></div>
				</div>
				<el-table :data="tableData" stripe border highlight-current-row style="width:100%"
					:header-cell-style="headerStyle" :cell-style="cellStyle">
					<el-table-column prop="url" label="引擎地址" width="380" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="heartbeat_url" label="心跳地址" width="280" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="concurrency" label="并发量">
					</el-table-column>
					<el-table-column prop="onlineStatus" label="在线状态">
					</el-table-column>
					<el-table-column prop="publishStatus" label="发布状态">
					</el-table-column>
				</el-table>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
				totalMemory:'',
				maxMemory:'',
				cpuRatio:''
			}
		},
	
		created() {
			this.getServerInfoRequest()
		},
	
		methods: {
			async getServerInfoRequest() {
				var api = "/manager/middleman/manage/machine/info"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
				})
	
				if (response.resultCode == 10000) {
					this.totalMemory = response.data.totalMemory
					this.maxMemory = response.data.maxMemory
					this.cpuRatio = response.data.cpuRatio
					this.tableData = response.data.robotList
				} else {
					this.$message.error(response.desc)
				}
			},
	
			headerStyle({ rowIndex, columnIndex }) {
				if (rowIndex == 0 && columnIndex == 5) {
					return 'text-align:center;color:#000000'
				} else {
					return 'text-align:left;padding:15px;color:#000000'
				}
			},
	
			cellStyle({ columnIndex }) {
				if (columnIndex == 5) {
					return 'text-align:center'
				} else {
					return 'text-align:left;padding:15px;'
				}
			},
		}
	}
</script>

<style scoped="scoped">
	.count {
		height: 3.75rem;
		width: 90%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		background-color: #FFFFFF;
	}
	
	.count1 {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		/* height: 30px; */
		text-align: center;
	}
	
	.count2 {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		/* height: 30px; */
		text-align: center;
		margin-left: 10px;
	}
	
	.count_span {
		/* height: 100%;	 */
		display: inline-block;
		vertical-align: middle;
		color: #409EFF;
		margin: 0 auto;
		line-height: 20px;
	}
	
	.count_span1 {
		/* height: 100%; */
		display: inline-block;
		vertical-align: middle;
		/* color: #409EFF; */
		margin: 0 auto;
		line-height: 20px;
	}
	
</style>
